import React from 'react';
import FieldItem from "./option-item/field-item";
import {SEPARATOR} from "../../../../../gd-components/popover-menu/const"
import {PopoverAddFieldsListProps} from "./index"
import FieldProto from "../../../../../fields3/proto/field-proto";

export default function SystemFields(props:PopoverAddFieldsListProps) {

    const group = _.find(props.config.groupedFields, group=>group.value === props.section)

    let separatorAdded = true; // required for separator to be placed only after any other option, not other separator

    const options: any[] = _(group?.items).map((field: FieldProto)=> {
        switch (field.fieldId) {
            case 'separator':
                if (separatorAdded) return false;
                separatorAdded = true;
                return field;

            default:
                separatorAdded = false;
                // return _.find(props.fields, (field)=>field.fieldId === field.fieldId)
                return field
        }
    }).compact().value();

    const hasIcons = !!_.find(options, o=>o.icon) || !!props.noValueOption?.icon;

    return (
        <>
            {_.map(options, (option, key)=> {
                switch (option.fieldId) {
                    case SEPARATOR  :
                        return <div key={key} className="separator"/>;

                    default         :
                        const selectedColumn = _.find(props.columns, column=>column.fieldId === option.fieldId)
                        const isSelectedField = _.intersection(props.selectedFieldIds, [option.fieldId, option.systemFieldId]).length > 0 //props.selectedFieldIds.includes(option.fieldId)

                        return (
                            <FieldItem
                                key                 = {option.fieldId}
                                field               = {option}
                                params              = {selectedColumn?.params}
                                selected            = {!!selectedColumn || isSelectedField}
                                hasIcons            = {hasIcons}
                                showModifierOptions = {props.showModifierOptions}
                                disabled            = {props.mandatoryColumnsIds?.includes(option.fieldId)}
                                onClick             = {props.onToggleColumn}
                            />
                        )
                }
            })}
        </>
    )
}
